import type { SVGAttributes } from "react";

/**
 * Matches the `@hightouch/htui` icon contract (1em box, 24x24 grid,
 * `currentColor`) so it works anywhere those icons do, e.g. `Badge.svgIcon`.
 */
export const HourglassIcon = (props: SVGAttributes<SVGElement>) => (
  <svg
    fill="currentColor"
    height="1em"
    viewBox="0 0 24 24"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      transform="translate(3 2)"
      d="M17 0C17.5523 0 18 0.447715 18 1C18 1.55228 17.5523 2 17 2H16V4.92969C16 5.87016 15.5593 6.75236 14.8164 7.31738L14.6641 7.42578L10.8027 10L14.6641 12.5742C15.4987 13.1306 16 14.0673 16 15.0703V18H17C17.5523 18 18 18.4477 18 19C18 19.5523 17.5523 20 17 20H1C0.447715 20 0 19.5523 0 19C0 18.4477 0.447715 18 1 18H2V15.0703C2.00003 14.0673 2.50131 13.1306 3.33594 12.5742L7.19727 10L3.33594 7.42578C2.50135 6.86939 2.00002 5.93273 2 4.92969V2H1C0.447715 2 0 1.55228 0 1C0 0.447715 0.447715 0 1 0H17ZM4.44531 14.2383C4.16719 14.4237 4.00003 14.736 4 15.0703V18H14V15.0703C14 14.736 13.8328 14.4237 13.5547 14.2383L9 11.2012L4.44531 14.2383ZM4 4.92969C4.00002 5.26402 4.16713 5.57627 4.44531 5.76172L9 8.79785L13.5547 5.76172C13.8329 5.57627 14 5.26402 14 4.92969V2H4V4.92969Z"
    />
  </svg>
);
